export default function sanitize(str) {
    return str.toString()
        .replace('%', '')
        .toLowerCase()
        .split(' ')
        .join('-')
}